import React, { useState, useRef } from "react";
import { Formik } from "formik";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { HemaHeadingWithSubText, HemaLabel, Button, Alert } from "../../utils";
import {
  CrossIcon,
  Site,
  Sponser,
  Study,
  SelectDownArrow,
  Switch,
} from "../../HemeIconLibrary";
import { setForm } from "../../Store/reducers/uiSettings";
import {
  setActiveSponsor,
  setActiveStudy,
  setActiveSite,
  setFilterSite,
} from "../../Store/reducers/users";

import { setAllKitsforSite } from "../../Store/reducers/orders";
import { getAvailabeKitsAction, checkSiteForKitsAccessAction, checkSiteForReportsAccessAction } from "../../Actions/orders";
import Modal from "react-bootstrap/Modal";
import Select from "../../utils/FormElements/select";
import SelectSearch from "../../utils/FormElements/singleSelect";

const LoginForm = ({ loginUser }) => {
  const [showModal, setShowModal] = useState(false);
  const [redirectPath, setRedirectPath] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const formikRef = useRef();
  const {
    user: { userStatus },
    user: { activeSponser, activeStudy, activeSite, filterStudy, filterSites },
    orders,
  } = useSelector((state) => state);
  const dispatch = useDispatch();
  return (
    <div
      className={
        location.pathname == "/login" ? "max-w-full lg:max-w-[450px]" : "w-full"
      }>
      <div className="flex gap-[13px] items-start">
        {location.pathname == "/login" ? (
          ""
        ) : (
          <div className="h-[48px] w-[48px] flex justify-center items-center bg-hemaSecondary rounded-full">
            <Site width="22" height="22" />
          </div>
        )}

        <HemaHeadingWithSubText
          HeadingFontSize="26px"
          HeadingLineHeight="31px"
          heading="Select the Site"
          sub="Please select the site you would like to access"
          subTextColor="#595959"
        />
      </div>

      {location.pathname == "/login" ? (
        ""
      ) : (
        <div className="w-full border-b border-dashed border-[#DEE2E6]  mt-[25px] mb-[23px]" />
      )}

      <Formik
        initialValues={{
          sponser: loginUser ? activeSponser : userStatus?.sponsors?.[0] || "",
          study: loginUser ? activeStudy : filterStudy?.[0] || "",
          site: loginUser ? activeSite : filterSites?.[0] || "",
        }}
        enableReinitialize
        validate={(values) => {
          const errors = {};
          if (!values.sponser) {
            errors.sponser = "Required";
          }
          if (!values.study) {
            errors.study = "Required";
          }
          if (!values.site) {
            errors.site = "Required";
          }
          console.log("values", values);
          return errors;
        }}
        onSubmit={async (values) => {
          console.log("values", values);
          if (loginUser) {
            if (orders.allKitsforSite?.filter((kit) => kit.addtocart)?.length) {
              setRedirectPath(location.pathname);
              setShowModal(true);
            } else {
              setRedirectPath(location.pathname);
              setShowModal(true);

              // console.log("t2 check");
              // dispatch(setActiveSponsor(values.sponser));
              // dispatch(setActiveStudy(values.study));
              // dispatch(setActiveSite(values.site));
              // localStorage.setItem(
              //   "portal-active-sponsor",
              //   values.sponser?.name
              // );
              // localStorage.setItem("portal-active-study", values.study?.name);
              // localStorage.setItem("portal-active-site", values.site?.name);
              // localStorage.setItem("portal-active-site-id", values.site?.id);

              // dispatch(setForm({ state: false, type: "" }));
              // //navigate("/");
              // //dispatch(setAllKitsforSite(null));
              // getAvailabeKitsAction(values.site?.id);
            }
          } else {
            console.log("t3 check");
            dispatch(setActiveSponsor(values.sponser));
            dispatch(setActiveStudy(values.study));
            dispatch(setActiveSite(values.site));
            checkSiteForKitsAccessAction(values.site?.id);
            checkSiteForReportsAccessAction(values.site?.id);
            localStorage.setItem("portal-active-sponsor", values.sponser?.name);
            localStorage.setItem("portal-active-study", values.study?.name);
            localStorage.setItem("portal-active-site", values.site?.name);
            localStorage.setItem("portal-active-site-id", values.site?.id);
            dispatch(setAllKitsforSite(null));
            getAvailabeKitsAction(values.site?.id);
            
            // Dispatch custom event for site change
            window.dispatchEvent(new CustomEvent('siteChanged', {
              detail: {
                siteId: values.site?.id,
                siteName: values.site?.name
              }
            }));
            navigate("/");
          }
        }}
        innerRef={formikRef}>
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isSubmitting,
          /* and other goodies */
        }) => (
          <>
            <form onSubmit={handleSubmit}>
              <div className="mt-[24px]">
                <Alert type="error" />
              </div>

              <div className="flex flex-col  mb-[24px] mt-[24px]">
                <HemaLabel
                  text="Sponsor"
                  Icon={<Sponser />}
                  textSize="text-[16px]"
                  required={true}
                  className="pb-[15px]"
                />
                <Select
                  setFieldValueFull={setFieldValue}
                  name="sponser"
                  disabled={userStatus?.sponsors?.length === 1 ? true : false}
                  placeholder={
                    loginUser
                      ? activeSponser?.name
                      : userStatus?.sponsors?.[0].name || "select user"
                  }
                  initialValues={values.sponser}
                  options={userStatus?.sponsors}
                  dispatch={dispatch}
                  userStatus={userStatus}
                  //  crossIcon={values.sponser && userStatus?.sponsors?.length !== 1 ? <CrossIcon /> : ""}
                  setFieldValue={setFieldValue}
                  dropIcon={
                    userStatus?.sponsors?.length !== 1 && <SelectDownArrow />
                  }
                />

                {errors.sponser && touched.sponser && (
                  <p className="error m-0  text-[#F54C3B]"> {errors.sponser}</p>
                )}
              </div>

              <div className="flex flex-col  mb-[24px] mt-[24px]">
                <HemaLabel
                  text="Study"
                  Icon={<Study />}
                  textSize="text-[16px]"
                  required={true}
                  className="pb-[15px]"
                />
                <Select
                  setFieldValueFull={setFieldValue}
                  name="study"
                  disabled={
                    userStatus?.studies?.filter(
                      (study) => study?.parentId === values?.sponser?.id
                    )?.length === 1
                      ? true
                      : false
                  }
                  // placeholder={loginUser ? activeStudy?.name : userStatus?.studies?.filter((study) => study.parentId === values?.sponser?.id)?.[0]?.name || 'select study'}
                  placeholder={
                    userStatus?.studies?.filter(
                      (study) => study?.parentId === values?.sponser?.id
                    )?.[0]?.name || "select study"
                  }
                  options={userStatus?.studies?.filter(
                    (study) => study.parentId === values?.sponser?.id
                  )}
                  initialValues={values.study}
                  dispatch={dispatch}
                  userStatus={userStatus}
                  // crossIcon={values.study && userStatus?.studies?.filter((study) => study?.parentId === values?.sponser?.id)?.length !== 1 ? <CrossIcon /> : ""}
                  dropIcon={
                    userStatus?.studies?.filter(
                      (study) => study?.parentId === values?.sponser?.id
                    )?.length !== 1 && <SelectDownArrow />
                  }
                  setFieldValue={setFieldValue}
                />

                {errors.study && touched.study && (
                  <p className="error m-0  text-[#F54C3B]"> {errors.study}</p>
                )}
              </div>
              <div className="flex flex-col  mb-[24px] mt-[24px]">
                <HemaLabel
                  text="Site"
                  Icon={<Site />}
                  textSize="text-[16px]"
                  required={true}
                  className="pb-[15px]"
                />
                <SelectSearch
                  setFieldValueFull={setFieldValue}
                  name="site"
                  
                  isClearable={false}
                  value={
                    userStatus?.sites?.filter(
                      (site) => site.parentId === values?.study?.id
                    )?.[0]?.id || "select site"
                  }
                  options={userStatus?.sites?.filter(
                    (site) => site?.parentId === values?.study?.id
                  )}
                  initialValues={values.site}
                  dispatch={dispatch}
                  // crossIcon={values.site && userStatus?.sites?.filter((site) => site?.parentId === values?.study?.id)?.length !== 1 ? <CrossIcon /> : ''}
                  dropIcon={
                    userStatus?.sites?.filter(
                      (site) => site?.parentId === values?.study?.id
                    )?.length !== 1 && <SelectDownArrow />
                  }
                  setFieldValue={setFieldValue}
                />

                {errors.site && touched.site && (
                  <p className="error m-0  text-[#F54C3B]"> {errors.site}</p>
                )}
              </div>

              <Button
                text="Continue"
                type="submit"
                bg="bg-primary1"
                border="border-primary1"
                color="text-white"
                className="w-full h-[48px] justify-center font-semibold"
              />
            </form>
          </>
        )}
      </Formik>

      <div className="">
        <Modal
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showModal}
          onHide={() => {
            setShowModal(false);
          }}
          animation={false}>
          <Modal.Header>
            <div className="flex flex-col justify-center items-center w-full gap-3 ">
              <Switch />
              <p
                className="main_heading font-semibold m-0"
                style={{ fontSize: "38px" }}>
                Switch site?
              </p>
            </div>
          </Modal.Header>

          <Modal.Body>
            <p className="text-sm mb-3 text-center">
              Are you sure you want to switch sites? Any progress will not be saved.
            </p>
          </Modal.Body>

          <Modal.Footer>
            <div className="flex gap-[20px]  items-center justify-end w-full">
              <Button
                type="button"
                text={"Cancel"}
                bg="bg-white"
                border="border-primary1"
                color="text-primary1"
                cta={() => {
                  setShowModal(false);
                }}
              />
              <Button
                text="Yes, Switch"
                type="button"
                bg="bg-primary1"
                color="text-white"
                cta={() => {
                  dispatch(setActiveSponsor(formikRef.current?.values.sponser));
                  dispatch(setActiveStudy(formikRef.current?.values.study));
                  dispatch(setActiveSite(formikRef.current?.values.site));
                  checkSiteForKitsAccessAction(formikRef.current?.values.site?.id);
                  checkSiteForReportsAccessAction(formikRef.current?.values.site?.id);
                  localStorage.setItem(
                    "portal-active-sponsor",
                    formikRef.current?.values.sponser?.name
                  );
                  localStorage.setItem(
                    "portal-active-study",
                    formikRef.current?.values.study?.name
                  );
                  localStorage.setItem(
                    "portal-active-site",
                    formikRef.current?.values.site?.name
                  );
                  localStorage.setItem(
                    "portal-active-site-id",
                    formikRef.current?.values.site?.id
                  );
                  localStorage.setItem("cart-item-ids", "");

                  dispatch(setForm({ state: false, type: "" }));
                  dispatch(setAllKitsforSite(null));
                  getAvailabeKitsAction(formikRef.current?.values.site?.id);
                  
                  // Dispatch custom event for site change
                  window.dispatchEvent(new CustomEvent('siteChanged', {
                    detail: {
                      siteId: formikRef.current?.values.site?.id,
                      siteName: formikRef.current?.values.site?.name
                    }
                  }));
                }}
              />
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default LoginForm;
